export default __webpack_public_path__ + "static/media/benefit_17@2x.3df9bcca.png";